var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 37233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 43250"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.71094 16.9997C3.71094 9.66051 9.66051 3.71094 16.9997 3.71094C24.3388 3.71094 30.2884 9.66051 30.2884 16.9997C30.2884 24.3388 24.3388 30.2884 16.9997 30.2884C9.66051 30.2884 3.71094 24.3388 3.71094 16.9997ZM16.9997 0.710938C8.00365 0.710938 0.710938 8.00365 0.710938 16.9997C0.710938 25.9957 8.00365 33.2884 16.9997 33.2884C25.9957 33.2884 33.2884 25.9957 33.2884 16.9997C33.2884 8.00365 25.9957 0.710938 16.9997 0.710938ZM8.00293 20.0623C8.17733 20.4258 8.5059 20.8014 8.78443 21.0895C9.10958 21.4259 9.53414 21.8118 10.0402 22.2042C11.047 22.985 12.4362 23.838 14.0789 24.3599C15.732 24.8852 17.6728 25.0831 19.7183 24.4955C21.7696 23.9064 23.7935 22.5653 25.6693 20.2362L23.3328 18.3545C21.7737 20.2904 20.2473 21.2223 18.8901 21.6121C17.5272 22.0036 16.2014 21.8865 14.9872 21.5008C13.7626 21.1117 12.6835 20.4577 11.8787 19.8336C11.4789 19.5235 11.1617 19.2324 10.9414 19.0045C10.8007 18.8589 10.7285 18.769 10.6995 18.7329C10.6894 18.7204 10.6845 18.7143 10.6839 18.7148C10.6833 18.7151 10.6862 18.721 10.6919 18.7324C10.6959 18.7404 10.7012 18.7511 10.7077 18.7645L8.00293 20.0623Z",
    fill: "#01684A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyIcon);
export default __webpack_public_path__ + "static/media/HappyIcon.8fbea190e44daf3a9e65a15cc6f66e0f.svg";
export { ForwardRef as ReactComponent };